import { Component, Input, OnInit, AfterViewInit, Optional, Self } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NgControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { QuestionOperator } from 'app/enums/question-operator.enum';
import { ComparableOperator, Question } from 'app/models/form';
import { ToastService } from 'app/services/toast.service';
import { BaseAnswerTypeComponent } from '../base-answer-type.component';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent extends BaseAnswerTypeComponent<number | number[]> implements OnInit {

  @Input() formGroup: UntypedFormGroup;
  @Input() controlName: string;
  @Input() labelFrom: string;
  @Input() labelTo: string;
  @Input() labelRange: string;
  @Input() placeholder: string = '';
  @Input() minDate: Date = null;
  @Input() detailMode: boolean = false;
  @Input() required: boolean = false;
  @Input() readonly: boolean = false;
  @Input() operatorAvailable: boolean = false;
  @Input() question: Question;

  form: UntypedFormGroup;
  mockPrevData = ['2022-09-05T03:00:00.000Z', '2022-09-08T03:00:00.000Z', 3];

  QUESTION_OPERATOR = QuestionOperator;
  operatorSelected: number = QuestionOperator.Equals;
  operatorsDisable: number[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private toastService: ToastService,
    private translateService: TranslateService,
    @Self()
    @Optional()
    ngControl?: NgControl,
    ) { 
    super(ngControl);
    this.form = this.fb.group({
      dateFrom: [null, Validators.required],
      dateTo: [null],
      calculatedDays: [0]
    });
  }

  calculateDaysDiference(a, b)
  {
    if(!a && b){
      return -1;
    }
    a = new Date(a);
    b = new Date(b);
    let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    let result = Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
    if(result < 0){
      return -1;
    }else{
      return result;
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    // console.log(this.ngControl.control)
    
    if(this.readonly){
      this.form.disable();
    }
    
    if(this.required && this.ngControl.control?.value){
      if(!this.ngControl.control?.value[0]){
        this.ngControl.control.setErrors({'dateFromInvalid': true});
      }
    }
    
    if(this.ngControl.control?.value?.length > 0){
      this.form.get('dateFrom').setValue(this.ngControl.control?.value[0] ?? null);
      this.form.get('dateTo').setValue(this.ngControl.control?.value[1] ?? null);
      this.form.get('calculatedDays').setValue(this.ngControl.control?.value[2] ?? 0);

      if(this.question.questionOperatorId){
        this.operatorSelected = this.question.questionOperatorId;
        if(this.question.questionOperatorId == this.QUESTION_OPERATOR.Between){
          this.operatorsDisable = [this.QUESTION_OPERATOR.Equals, this.QUESTION_OPERATOR.HigherThan, this.QUESTION_OPERATOR.LessThan, this.QUESTION_OPERATOR.Completed, this.QUESTION_OPERATOR.Empty, this.QUESTION_OPERATOR.DateFromWithValue];
        }
      }

      if(this.ngControl.control?.value[0] && !this.ngControl.control?.value[1]){
        let resultDifference  = this.calculateDaysDiference(this.ngControl.control?.value[0], new Date());
        setTimeout(()=>{
          if(resultDifference > 0){
            this.form.get('calculatedDays').setValue(resultDifference);
          }else{
            this.form.get('calculatedDays').setValue(0);
          }
        },100);
      }
    }
    this.form.get('calculatedDays').disable();
    this.form.valueChanges.subscribe(changes => {
      if(changes.dateFrom && changes.dateTo){
        let resultDifference  = this.calculateDaysDiference(changes.dateFrom, changes.dateTo);
        if(this.form.get('calculatedDays').value !== resultDifference){
          this.form.get('calculatedDays').setValue(resultDifference);
        }else{
          if(resultDifference == -1){
            setTimeout(()=>{
              this.form.get('dateTo').setValue(null);
              this.form.get('calculatedDays').setValue(0);
            },50)
            let msg = this.translateService.instant("DATE_RANGE.CANNOT_SET_DATETO_LESS_THAN_DATEFROM");
            this.toastService.error(msg);
          }
        }
        this.operatorSelected = this.QUESTION_OPERATOR.Between;
        this.operatorsDisable = [this.QUESTION_OPERATOR.Equals, this.QUESTION_OPERATOR.HigherThan, this.QUESTION_OPERATOR.LessThan, this.QUESTION_OPERATOR.Completed, this.QUESTION_OPERATOR.Empty, this.QUESTION_OPERATOR.DateFromWithValue]
      }else if(changes.dateFrom && !changes.dateTo){
        let resultDifference  = this.calculateDaysDiference(changes.dateFrom, new Date());
        setTimeout(()=>{
          if(resultDifference > 0){
            this.form.get('calculatedDays').setValue(resultDifference);
          }else{
            this.form.get('calculatedDays').setValue(0);
          }
        },100);
        if(this.operatorSelected == this.QUESTION_OPERATOR.Between){
          this.operatorSelected = this.QUESTION_OPERATOR.Equals;
        }
        this.operatorsDisable = [this.QUESTION_OPERATOR.Between];
      }else if(!changes.dateFrom && changes.dateTo){
        let resultDifference  = this.calculateDaysDiference(changes.dateFrom, changes.dateTo);
        if(resultDifference == -1){
          setTimeout(()=>{
            // this.form.get('dateTo').setValue(null);
            this.form.get('calculatedDays').setValue(0);
          },50)
          // let msg = this.translateService.instant("DATE_RANGE.CANNOT_SET_DATETO_LESS_THAN_DATEFROM");
          // this.toastService.error(msg);
          if(this.operatorSelected == this.QUESTION_OPERATOR.Between){
            this.operatorSelected = this.QUESTION_OPERATOR.Equals;
          }
          this.operatorsDisable = [this.QUESTION_OPERATOR.Between];
        }
      }else{
        setTimeout(()=>{
          this.form.get('calculatedDays').setValue(0);
        },100);
      }

      let controlValue = [this.form.get('dateFrom').value,this.form.get('dateTo').value,this.form.get('calculatedDays').value];

      if(this.operatorAvailable){
        controlValue = [this.form.get('dateFrom').value,this.form.get('dateTo').value,this.form.get('calculatedDays').value, this.operatorSelected];
      }

      this.ngControl.control.setValue(controlValue);
      if(!this.form.get('dateFrom').value){
        this.ngControl.control.setErrors({'dateFromInvalid': true});
      }
    });
    this.ngControl.control?.valueChanges.subscribe(
      changes => {
        if(!changes){
          this.form.reset();
          this.operatorSelected = QuestionOperator.Equals;
          this.operatorsDisable = [];
        }
      }
    );
  }

  handleKeyDown(e: KeyboardEvent){
    if(e.code !== "Backspace"){
      e.preventDefault();
      return;
    }
  }

  handleQuestionOperator(operator: MatRadioChange){
    this.operatorSelected = operator.value;
    this.form.get('dateFrom').setValue(this.form.get('dateFrom').value);
    if(this.operatorSelected == this.QUESTION_OPERATOR.DateFromWithValue){
      setTimeout(()=>{
        this.form.get('dateTo').setValue(null);
        this.form.get('dateTo').disable();
      },200)
    }else{
      this.form.get('dateTo').enable();
    }
  }

  getError(errorCode: string) {
    // Enables the control for getting the error properly

    // this.formGroup.get(this.controlName).enable();
    // const hasError: boolean = this.formGroup.get(this.controlName).hasError(errorCode);
    // this.formGroup.get(this.controlName).disable();
    // return hasError; 
  }

  /**
   * For this operations SelectInputComponent will not manage multiple selection. For that, use SelectMultipleInputComponent
   */
     AllowedOperators: {[K in ComparableOperator]: (target: number, value: string) => boolean} = {
    [ComparableOperator.Equal]: (t, value: string) => t == Number(value),
    [ComparableOperator.NotEqual]: (t, value) => t != Number(value),
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: (t, value: string) => value.split(";").map(v => Number(v)).includes(t),
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (t) => !t,
    [ComparableOperator.NotIsNullOrEmpty]: (t) => !!t,
    [ComparableOperator.Between]: null,
    [ComparableOperator.Empty]: null,
    [ComparableOperator.Completed]: null,
  }

}
